module.exports = __webpack_public_path__ + "img/sh002-003.be2d1914.jpg";